import { Apple, Snowflake, Beef, SprayCan, Wheat, Users, Package, Fish, Croissant, ChefHat, CupSoda, Wine } from 'lucide-react';

export const UNIT_OPTIONS = ['kg', 'ltr', 'pce', 'colis'];
export const CATEGORY_LABEL = { CK: 'CUISINE' };
export const DEFAULT_CFG = { icon: Package, color: 'text-gray-500', bg: 'bg-gray-100', border: 'border-gray-200' };

export const CATEGORY_CONFIG = {
  FRAIS: { icon: Apple, color: 'text-emerald-600', bg: 'bg-emerald-500/10', border: 'border-emerald-500/30' },
  BOF: { icon: Package, color: 'text-amber-700', bg: 'bg-amber-50', border: 'border-amber-300' },
  BOUCHERIE: { icon: Beef, color: 'text-red-600', bg: 'bg-red-500/10', border: 'border-red-500/30' },
  POISSONS: { icon: Fish, color: 'text-sky-600', bg: 'bg-sky-500/10', border: 'border-sky-500/30' },
  EPICERIE: { icon: Wheat, color: 'text-orange-600', bg: 'bg-orange-500/10', border: 'border-orange-500/30' },
  PATISSERIE: { icon: Croissant, color: 'text-yellow-700', bg: 'bg-yellow-50', border: 'border-yellow-300' },
  CK: { icon: ChefHat, color: 'text-violet-600', bg: 'bg-violet-500/10', border: 'border-violet-500/30' },
  BOISSONS: { icon: CupSoda, color: 'text-teal-600', bg: 'bg-teal-500/10', border: 'border-teal-500/30' },
  VINS: { icon: Wine, color: 'text-rose-700', bg: 'bg-rose-50', border: 'border-rose-300' },
  HYGIENE: { icon: SprayCan, color: 'text-cyan-600', bg: 'bg-cyan-500/10', border: 'border-cyan-500/30' },
  // anciennes catégories (commandes historiques)
  'FRUITS ET LEGUMES': { icon: Apple, color: 'text-emerald-600', bg: 'bg-emerald-500/10', border: 'border-emerald-500/30' },
  CONGELATEUR: { icon: Snowflake, color: 'text-blue-600', bg: 'bg-blue-500/10', border: 'border-blue-500/30' },
  BOULANGERIE: { icon: Wheat, color: 'text-yellow-700', bg: 'bg-yellow-50', border: 'border-yellow-300' },
  'REPAS STAFF': { icon: Users, color: 'text-purple-600', bg: 'bg-purple-500/10', border: 'border-purple-500/30' },
};

export const catCfg = (cat) => CATEGORY_CONFIG[cat] || DEFAULT_CFG;
export const catLabel = (cat) => CATEGORY_LABEL[cat] || cat;
